<!-- eslint-disable max-len -->
<template>
  <div class="py-6">
    <div
      v-if="isLoadingReport || (!isLoadingReport && hasSomeCorrectRate)"
      class="quizzes-summary __container"
    >
      <div class="quizzes-summary __progress">
        <aha-progress-circle
          v-if="!isLoadingReport"
          v-show="avgCorrectRate !== null"
          class="mr-3"
          inner-circle-color=""
          progress-bar-color="#33C173"
          :percent="avgCorrectRate"
          :radius="25"
          :ring-width="9"
          box-shadow="0px 10.1706px 9.38822px rgba(51, 193, 115, 0.1)"
          inner-box-shadow="inset 1px 1px 6px rgba(51, 193, 115, 0.1)"
        />
        <aha-progress-circle
          v-else
          class="mr-3"
          progress-bar-color="#EFF1F7"
          :percent="25"
          :radius="25"
          :ring-width="9"
          box-shadow="none"
          inner-box-shadow="none"
        />
        <span
          v-if="hasSomeCorrectRate"
          class="quizzes-summary __number"
        >
          {{ avgCorrectRate }}%
        </span>
      </div>
      <div class="quizzes-summary __content">
        <p
          class="font-bold quizzes-summary __title"
          :class="{'text-secondary-40': isLoadingReport, 'text-secondary-100': !isLoadingReport}"
        >
          {{ $i18nPresenter.t('Correct rate') }}
        </p>
        <p
          class="quizzes-summary __copy"
        >
          <span
            v-if="!isLoadingReport && hasSomeCorrectRate"
          >
            {{ $i18nPresenter.t('Of all quiz answers submitted') }}, {{ avgCorrectRate }}% {{ $i18nPresenter.t('were correct.') }}
            <span
              class="cursor-pointer fas fa-question-circle text-secondary-40"
              v-tooltip="$i18nPresenter.t('This also includes multiple choice questions where an answer was marked as correct.')"
            />
          </span>
          <span
            v-else
            class="flex flex-col mt-1"
          >
            <aha-skeleton-loader
              class="mb-1"
              width="70%"
              height="12px"
            />
            <aha-skeleton-loader
              width="30%"
              height="12px"
            />
          </span>
        </p>
      </div>
    </div>
    <div
      v-if="!isLoadingReport && !hasSomeCorrectRate"
      class="text-center"
    >
      <div class="inline-block mb-6">
        <img
          src="@/assets/images/report/quiz.svg"
          width="172"
          height="100"
          alt=""
        >
      </div>

      <div class="font-bold mb-1">
        {{ $i18nPresenter.t("Your didn't add quiz.") }}
      </div>
      <div class=" text-sm">
        {{ $i18nPresenter.t('Quiz excites the crowd. Try it next time!') }}
      </div>
    </div>
    <report-difficult-questions />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReportDifficultQuestions from '@/components-v2/presentation-report/ReportDifficultQuestions.vue'

export default {
  components: {
    ReportDifficultQuestions,
  },
  props: {},
  computed: {
    ...mapGetters('presentationReport', ['avgCorrectRate', 'presentationReport', 'isLoadingReport']),
    hasSomeCorrectRate() {
      if (!this.presentationReport ||
        !this.presentationReport.extended ||
        !this.presentationReport.extended.slides
      ) {
        return false
      }
      return this.presentationReport.extended.slides
        .some((slide) => slide.correctRate !== null)
    },
  },
}
</script>

<style lang="scss" scoped>
.quizzes-summary {
  &.__container {
    @apply p-3 flex flex-row rounded-lg mb-2.5 bg-base-0;
    box-shadow: 0px 2px 6px rgba(211, 215, 225, 0.65);
  }

  &.__progress {
    @apply relative;
  }
  &.__number {
    @apply absolute top-0 -left-1;
    @apply w-full h-full flex items-center justify-center;
    @apply font-bold text-xs;
  }
  &.__content {
    @apply flex flex-col justify-center;
  }
}
</style>
